<template>
  <div class="card">
    <slot></slot>
  </div>
</template>

<style scoped>
.card {
  margin: 2rem auto;
  padding: 0rem 1rem;
}
</style>
